import {Component, Input} from '@angular/core';
import { CommonModule } from '@angular/common';
import {FlexModule} from '@angular/flex-layout';
import {FontAwesomeModule} from '@fortawesome/angular-fontawesome';
import {PipesModule} from '@app/core/pipes/pipes.module';
import {PII_LEVEL} from '@app/views/admin/application-settings/components/basic/pii-shield-level-info/pii-shield.model';

@Component({
    selector: 'ngc-pii-shield-entities-attributes',
    standalone: true,
    imports: [CommonModule, FlexModule, FontAwesomeModule, PipesModule],
    templateUrl: './pii-shield-entities-attributes.component.html',
    styleUrls: ['./pii-shield-entities-attributes.component.scss']
})
export class PIIShieldEntitiesAttributesComponent {

    @Input() piiShieldEntitiesAttributes: PIIShieldEntityAttributes[] = [];
    @Input() actionClass: string;
}

export class PIIShieldEntityAttributes {
    constructor(
        public entityType: string,
        public attributes: PIIShieldAttribute[] = []) {
    }
}

export class PIIShieldAttribute {
    constructor(
        public propertyName: string = '',
        public friendlyName: string = '',
        public piiLevel: PII_LEVEL
    ) {
    }
}

